import { TaskRecord } from './types';

// Port puro do matchesSearch do ApreciarRealizacao/index.tsx (campos UI-05). No
// original a normalização do termo (colapso de espaços, trim, caixa baixa) era feita
// pelo chamador; aqui ela vive dentro da função para torná-la total — as operações são
// idempotentes, então chamadores que já normalizam não mudam de comportamento.
export function matchesSearch(item: Partial<TaskRecord>, search: string): boolean {
  const _search = typeof search === 'string' ? search.replace(/ +/gi, ' ').trim().toLowerCase() : '';

  const fields = [
    item.description,
    item.owner,
    item.result,
    item.title,
    item.original_manager_detail?.chave,
    item.original_manager_detail?.nome,
  ];

  if (Array.isArray(item.evaluator_detail) && item.evaluator_detail.length) {
    item.evaluator_detail.forEach((ed: any) => {
      fields.push(ed.chave, ed.nome);
    });
  }

  if (Array.isArray(item.target) && item.target.length) {
    item.target.forEach((targetItem: any) => {
      fields.push(targetItem.name, targetItem._id);
    });
  }

  return fields.some(field => typeof field === 'string' && field.toLowerCase().includes(_search));
}
